import { FieldInput } from '../../../../../../components/redux-form/fields/FieldInput';
import React from 'react';
import classNames from 'classnames';
import styles from './assets/substitution-form.module.scss';
import { FieldDropdown } from '../../../../../../components/redux-form/fields/FieldDropdown';

const RenderFieldArray = (props: any) => {
    const { fields, caseNumbers } = props;
    return (
        <ul className={classNames(styles.ul)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields caseNumbers={caseNumbers} member={member} fields={array} index={index} />
            ))}
        </ul>
    );
};

type Props = {
    member: any;
    index: number;
    fields: any;
    caseNumbers: { [key: string]: string | null }[];
};

const RenderSubFields: React.FunctionComponent<Props> = ({ member, index, fields, caseNumbers }) => {
    const row = fields.get(index);
    const creditStyle = {
        background: 'grey',
    };
    const arrCases: SelectObject[] = [];

    caseNumbers.forEach((it) => {
        if (it.caseNumber) {
            arrCases.push({ label: it.caseNumber, value: it.caseNumber });
        }
    });

    return (
        <li style={+row.status === 2 ? creditStyle : {}} className="d-flex flex-row w-100" key={index}>
            <FieldInput
                name={`${member}.amount`}
                type="number"
                disabled={true}
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Amount, $:',
                }}
            />
            <FieldDropdown
                name={`${member}.caseNumber`}
                data={arrCases}
                disabled={true}
                textField={'label'}
                withSearchInput={true}
                valueField={'value'}
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Case Number:',
                }}
            />

            <FieldInput
                name={`${member}.comment`}
                type="text"
                disabled={true}
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Comment: *',
                }}
            />
        </li>
    );
};
export default RenderFieldArray;
